import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 32, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.12 }}
    transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, index }) => (
  <div className="flex items-center gap-3 font-mono text-xs uppercase tracking-[0.25em] text-[#00F0FF]">
    {index && <span className="text-slate-400">{index}</span>}
    <span className="h-px w-8 bg-[#00F0FF]/60" />
    <span>{children}</span>
  </div>
);
